<template>
  <div>
    <div class="q-pa-none">
      <div class="row full-width">
        <div style="width: 75%">
          <div class="row header items-center q-pa-lg bg-accent full-width">
            <div style="width: 100%">
              <span class="page-title"> Articles and Insights </span>
              <br />
              <div class="row items-center">
                <span class="filter-label"> Viewing Articles Related to </span>

                <sustainability-dropdown
                  :model="selectedOutcome"
                  class="q-ml-sm"
                  :style="`width: 300px;
                      background-color: rgba(255,255, 255, 0.3);
                      border-radius: 5px;
                      `"
                  :options="outcomesList"
                  :isObjects="true"
                  objectKey="label"
                  @input="selectOutcome"
                ></sustainability-dropdown>
                <!-- <q-select
                  class="q-ml-sm"
                  style="width: 80px"
                  v-model="articleFilter"
                  dense
                  filled
                  :options="[]"
                >
                  <template v-slot:dropdown-icon>
                    <q-icon name="fas fa-chevron-down" color="white"> </q-icon>
                  </template>
                  <template v-slot:selected>
                    <span class="text-bold text-white filter-label-bold">
                      {{ articleFilter }}
                    </span>
                  </template>
                </q-select> -->
              </div>
            </div>
          </div>
          <div class="row q-px-md q-py-sm">
            <div class="col-12">
              <div class="row justify-between">
                <div class="row items-center">
                  <div class="q-mr-sm search-label">Search By Keyword</div>
                  <div>
                    <q-input
                      v-model="search"
                      color="accent"
                      style="width: 133px"
                      filled
                      dense
                    >
                    </q-input>
                  </div>
                </div>
                <div class="row items-center">
                  <div class="q-mr-sm search-label">Sort By</div>
                  <div>
                    <q-select
                      style="width: 133px"
                      v-model="sortBy"
                      :options="sortByOptions"
                      color="accent"
                      filled
                      dense
                    >
                    </q-select>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="row">
                <div class="col">
                  <div
                    class="row justify-center"
                    style="height: calc(100vh - 270px)"
                  >
                    <div
                      v-for="(article, i) in filteredArticlesList"
                      :key="i"
                      class="q-py-md q-px-sm"
                    >
                      <grid-card
                        class="cursor-pointer"
                        @onClick="openArticle(article)"
                        :imageUrl="article.imageUrl"
                        :iconImageUrl="
                          getOutcomeImage({ name: article.outcomeName })
                        "
                        :headerSmallLeft="
                          $options.filters.articleCardDate(article.created_at)
                        "
                        :headerSmallRight="
                          article.totalReadMins.toFixed(0) + 'mins'
                        "
                        :mainHeader="article.title"
                        :descriptionHTML="article.description"
                        bottomIcon="mdi-eye-outline"
                        :bottomIconText="`(${article.views})`"
                      >
                      </grid-card>
                    </div>
                  </div>
                  <div class="row justify-end pagination items-center">
                    <div class="q-mr-sm">
                      Page
                      <span class="text-bold q-mx-xs">
                        {{ currentPage }}
                      </span>
                      - {{ maxPage }} of {{ articlesList.length }} Results
                    </div>
                    <q-btn
                      icon="fas fa-chevron-left"
                      flat
                      :color="isMinPage ? 'grey-5' : 'primary'"
                      :disable="isMinPage"
                      round
                      @click="nextPage(false)"
                    >
                    </q-btn>
                    <q-btn
                      icon="fas fa-chevron-right"
                      flat
                      :color="isMaxPage ? 'grey-5' : 'primary'"
                      :disable="isMaxPage"
                      round
                      @click="nextPage(true)"
                    >
                    </q-btn>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style="width: 25%" class="q-pt-xl q-px-md sidebar_wrapper">
          <side-bar title="Article information">
            <div
              style="padding: 10px; height: calc(100vh - 146px); width: 322px"
            >
              <div class="row q-mb-sm">
                <span class="text-bold q-mr-xs"> All </span>
                Articles
              </div>
              <div class="row q-mb-sm">
                <span class="value">
                  {{ filteredArticlesList.length }}
                </span>
              </div>
              <div class="row q-mb-sm">
                <span> Most recent article</span>
              </div>
              <div class="row q-mb-sm">
                <span class="value">
                  {{ mostRecentArticleFormattedDate }}
                </span>
              </div>
              <div class="row q-mb-sm">
                <span class="value">
                  <span v-if="mostRecentArticle">
                    “{{ mostRecentArticle.title }}”
                  </span>
                  <span v-else> None </span>
                </span>
              </div>

              <div class="row q-mb-sm">Average read time per article</div>
              <div class="row q-mb-sm">
                <span class="value">
                  {{
                    isNaN(totalAverageArticleReadMinutes.toFixed(0))
                      ? 0
                      : totalAverageArticleReadMinutes.toFixed(0)
                  }}mins
                </span>
              </div>
            </div>
          </side-bar>
        </div>
      </div>
    </div>

    <q-dialog v-model="researchAndInsightsDialog" persistent>
      <research-and-insights-dialog
        @closeDialog="closeDialog"
      ></research-and-insights-dialog>
    </q-dialog>
  </div>
</template>
<script>
  import { mapGetters } from "vuex";
  import moment from "moment";
  import { getOutcomeImage } from "@/functions/getOutcomeImage";
  import researchAndInsightsDialog from "@/components/researchAndInsights/researchAndInsightsDialog.vue";
  import GridCard from "@/components/datatable/gridCard.vue";
  import SideBar from "@/components/sidebar/sidebar.vue";
  import SustainabilityDropdown from "@/components/sustainabilityDropdown/sustainabilityDropdown.vue";

  export default {
    components: {
      researchAndInsightsDialog,
      SideBar,
      GridCard,
      SustainabilityDropdown,
    },
    watch: {
      $route: {
        handler() {
          this.handleRoute();
        },
        deep: true,
      },
    },
    data: () => ({
      researchAndInsightsDialog: false,
      articleFilter: "All",
      search: "",

      sortBy: "Oldest",
      sortByOptions: ["Latest", "Oldest"],

      mostRecentArticle: null,
      searchKeyword: "",

      //pagination
      itemsPerPage: 4,
      currentPage: 1,

      selectedOutcome: {
        id: null,
        name: "All",
      },
    }),
    computed: {
      ...mapGetters({
        outcomesList: "outcomes/listIncludeAll",
        articlesList: "articles/list",
      }),

      totalArticles() {
        return this.articlesList.length;
      },
      maxPage() {
        return Math.ceil(this.articlesList.length / this.itemsPerPage);
      },
      isMaxPage() {
        if (
          this.currentPage ==
          Math.ceil(this.articlesList.length / this.itemsPerPage)
        ) {
          return true;
        } else {
          return false;
        }
      },
      isMinPage() {
        if (this.currentPage == 1) {
          return true;
        } else {
          return false;
        }
      },
      mostRecentArticleFormattedDate() {
        if (this.articlesList.length > 0) {
          return moment(
            new Date(
              Math.max(
                ...this.articlesList.map((e, i) => {
                  this.mostRecentArticle = this.articlesList[i];
                  return new Date(moment.utc(e.created_at).local().format());
                })
              )
            )
          ).format("D MMMM YYYY");
        } else {
          return "";
        }
      },
      selectedOutcome() {
        return this.outcomesList.find((e) => e.id == this.$route.params.id);
      },
      totalAverageArticleReadMinutes() {
        let totalMinutes = 0;
        this.articlesList.forEach((e) => {
          totalMinutes += e.totalReadMins;
        });
        return totalMinutes / this.articlesList.length;
      },
      filteredArticlesList() {
        let articlesList = [...this.articlesList];

        articlesList = articlesList.filter((e) => {
          let searchMatch = false;
          let outcomeMatch = false;
          if (this.search) {
            let val = `${e.title} ${e.description}`;
            searchMatch =
              val.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
          } else {
            searchMatch = true;
          }

          if (
            !this.selectedOutcome.id ||
            this.selectedOutcome.id == e.outcomes_id
          ) {
            outcomeMatch = true;
          }

          return searchMatch && outcomeMatch;
        });

        if (this.sortBy == "Latest") {
          articlesList.sort((a, b) => (b.created_at > a.created_at ? 1 : -1));
          console.log("latest");
        } else {
          articlesList.sort((a, b) => (b.created_at > a.created_at ? -1 : 1));
          console.log("other");
        }
        return this.paginate(articlesList, this.itemsPerPage, this.currentPage);
      },
    },
    mounted() {
      this.$store.dispatch("outcomes/loadAll");
      this.init();
    },
    methods: {
      init() {
        this.$store.dispatch("articles/loadAll").then(() => {
          this.handleRoute();
        });
      },
      closeDialog() {
        this.$router.push("/researchAndInsightsView");
        this.researchAndInsightsDialog = false;
      },
      openArticle(article) {
        this.$router.push("/researchAndInsightsView/" + article.id);
        this.$store
          .dispatch("articles/saveNoLoad", {
            ...article,
            views: article.views + 1,
          })
          .then(() => {
            this.init();
          });
      },
      handleRoute() {
        if (this.$route.params.hasOwnProperty("id")) {
          this.$store
            .dispatch("articles/loadByID", this.$route.params.id)
            .then(() => {
              this.researchAndInsightsDialog = true;
            });
        }
      },
      getOutcomeImage: getOutcomeImage,
      paginate(array, page_size, page_number) {
        return array.slice(
          (page_number - 1) * page_size,
          page_number * page_size
        );
      },
      nextPage(isNext) {
        if (isNext) {
          if (
            this.currentPage <
            Math.ceil(this.articlesList.length / this.itemsPerPage)
          ) {
            this.currentPage = this.currentPage + 1;
          }
        } else {
          if (this.currentPage > 1) {
            this.currentPage = this.currentPage - 1;
          }
        }
      },
      selectOutcome(outcome) {
        console.log(outcome);
        this.selectedOutcome = outcome;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .header {
    height: 109px;
  }

  .sidebar_wrapper {
    background-color: #f6f6f6;
    font-family: "Montserrat";
    font-style: normal;

    .title {
      font-size: 14px;
    }

    .value {
      color: #162c47;
      font-weight: 900;
      font-size: 20px;
    }
  }

  .pagination {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 400;
    font-size: 11.6054px;
  }
  .filter-label {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    color: white;
  }
  .filter-label-bold {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    color: white;
  }

  .search-label {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 500;
    font-size: 11.6054px;
  }

  .page-title {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    color: white;
  }

  .back-button {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 500;
    font-size: 9px;
    width: 153px;
    height: 40px;
  }

  .orderBy-text {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 500;
    font-size: 6px;
  }

  .card-info {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 900;
    font-size: 14px;
  }

  .card-info-title {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 11px;
  }

  .card-info-text {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 900;
    font-size: 24px;
  }

  .card-info-article-preview {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 900;
    font-size: 16px;
    color: #4ac7e9;
  }

  .paginationText {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 500;
    font-size: 14.6054px;
    line-height: 14px;
  }

  .article-card {
    height: 293px;
    width: 217px;
    background-color: #f6f6f6;

    .date {
      font-family: "Montserrat";
      font-style: normal;
      font-weight: 700;
      font-size: 7.97588px;
      color: rgba(22, 44, 71, 0.5);
    }

    .outcome {
      font-family: "Montserrat";
      font-style: normal;
      font-weight: 700;
      font-size: 12px;
      color: #4ac7e9;
    }

    .title {
      font-family: "Montserrat";
      font-style: normal;
      font-weight: 700;
      font-size: 10.9668px;
      color: #162c47;
    }

    .description {
      font-family: "Montserrat";
      font-style: normal;
      font-weight: 400;
      font-size: 9.96985px;
      color: rgba(22, 44, 71, 0.5);
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 5;
      -webkit-box-orient: vertical;
    }

    .minutes {
      font-family: "Montserrat";
      font-style: normal;
      font-weight: 700;
      font-size: 7.97588px;
      color: rgba(22, 44, 71, 0.5);
    }
  }
</style>
